import { $apiAllo } from '@/services/api-allo/client';

export const POWER_DIALER_SCOPE = 'DIALING_QUEUE_READ_WRITE';

export const POWER_DIALER_ATTIO_API_KEY_SCOPES = [
  'DIALING_QUEUE_READ_WRITE',
  'USERS_READ',
] as const;

type ApiKeyListItem = {
  pid?: string;
  scopes?: string[];
};

export const useHasPowerDialerApiKey = (): { hasApiKey: boolean; isLoading: boolean } => {
  const { data, isLoading } = $apiAllo.useQuery('get', '/v1/api-keys', {});

  const keys = (data as { keys?: ApiKeyListItem[] } | undefined)?.keys ?? [];
  return {
    hasApiKey: keys.some((key) => key.scopes?.includes(POWER_DIALER_SCOPE)),
    isLoading,
  };
};
